<script setup>
</script>
<template>
  <div
    class="text-primary-text mb-10 w-full px-4 pt-[88px] md:mx-auto md:px-8 xl:px-16"
  >
    <div class="mx-auto 4xl:max-w-[1792px]">
      <div
        class="mb-3 flex flex-col items-start justify-between gap-3 md:flex-row md:items-center"
      >
        <h1
          class="text-[32px] font-semibold leading-[110%] tracking-[-0.064px]"
        >
          Stocks under 50
        </h1>
        <span class="text-xs leading-[18px] tracking-[-0.12px] text-text-2"
          >Last updated on
          <!-- -->28 Feb, 2025 | 19:20<!-- -->
          IST | NSE</span
        >
      </div>
      <div class="flex flex-col items-center justify-between gap-3 sm:flex-row">
        <p
          class="w-full text-xs leading-[18px] tracking-[-0.12px] text-text-2 sm:max-w-[519px] lg:max-w-[712px]"
        >
          Stocks under ₹50 provide an attractive opportunity to investors who
          want affordable equity market investments. These low-value stocks
          offer an appealing entry point for investors with a limited budget and
          those who want to diversify portfolios. However, investors should
          conduct a thorough research and an analysis of key factors to reduce
          risks associated with these penny stocks, while increasing the chances
          of making gains.
        </p>
      </div>
    </div>
    <div class="table-wrapper mx-auto overflow-x-auto 4xl:max-w-[1792px]">
      <table class="min-w-full 4xl:max-w-[1792px]">
        <thead>
          <tr>
            <th>
              <div class="flex justify-start">
                <span class="cursor-pointer">Name</span>
              </div>
            </th>
            <th>
              <div class="flex justify-end">
                <span class="cursor-pointer">LTP</span>
                <div class="ml-1 h-4 w-4">
                  <img
                    alt="filter up"
                    loading="lazy"
                    width="16"
                    height="16"
                    decoding="async"
                    data-nimg="1"
                    class="cursor-pointer"
                    style="color: transparent"
                    src="/next-scrip-assets/SortTable.svg"
                  />
                </div>
              </div>
            </th>
            <th>
              <div class="flex justify-end">
                <span class="cursor-pointer">Change %</span>
                <div class="ml-1 h-4 w-4">
                  <img
                    alt="filter up"
                    loading="lazy"
                    width="16"
                    height="16"
                    decoding="async"
                    data-nimg="1"
                    class="cursor-pointer"
                    style="color: transparent"
                    src="/next-scrip-assets/SortTable.svg"
                  />
                </div>
              </div>
            </th>
            <th>
              <div class="flex justify-end">
                <span class="cursor-pointer">Volume</span>
                <div class="ml-1 h-4 w-4">
                  <img
                    alt="filter up"
                    loading="lazy"
                    width="16"
                    height="16"
                    decoding="async"
                    data-nimg="1"
                    class="cursor-pointer"
                    style="color: transparent"
                    src="/next-scrip-assets/SortTable.svg"
                  />
                </div>
              </div>
            </th>
            <th>
              <div class="flex justify-end">
                <span class="cursor-pointer text-text-link"
                  >Market Cap (Cr.)</span
                >
                <div class="ml-1 h-4 w-4">
                  <img
                    alt="filter up"
                    loading="lazy"
                    width="16"
                    height="16"
                    decoding="async"
                    data-nimg="1"
                    class="cursor-pointer rotate-180"
                    style="color: transparent"
                    src="/next-scrip-assets/asc.svg"
                  />
                </div>
              </div>
            </th>
            <th>
              <div class="flex justify-end">
                <span class="cursor-pointer">52W high</span>
                <div class="ml-1 h-4 w-4">
                  <img
                    alt="filter up"
                    loading="lazy"
                    width="16"
                    height="16"
                    decoding="async"
                    data-nimg="1"
                    class="cursor-pointer"
                    style="color: transparent"
                    src="/next-scrip-assets/SortTable.svg"
                  />
                </div>
              </div>
            </th>
            <th>
              <div class="flex justify-end">
                <span class="cursor-pointer">52W low</span>
                <div class="ml-1 h-4 w-4">
                  <img
                    alt="filter up"
                    loading="lazy"
                    width="16"
                    height="16"
                    decoding="async"
                    data-nimg="1"
                    class="cursor-pointer"
                    style="color: transparent"
                    src="/next-scrip-assets/SortTable.svg"
                  />
                </div>
              </div>
            </th>
            <th>
              <div class="flex justify-end">
                <span class="cursor-pointer">Prev Close</span>
              </div>
            </th>
            <th>
              <div class="flex justify-end">
                <span class="cursor-pointer">PE Ratio</span>
                <div class="ml-1 h-4 w-4">
                  <img
                    alt="filter up"
                    loading="lazy"
                    width="16"
                    height="16"
                    decoding="async"
                    data-nimg="1"
                    class="cursor-pointer"
                    style="color: transparent"
                    src="/next-scrip-assets/SortTable.svg"
                  />
                </div>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <div
                class="flex cursor-pointer items-center break-words justify-start"
                style="word-break: break-word"
              >
                <a href="/stocks/indian-overseas-bank-share-price/INE565A01014/"
                  >INDIAN OVERSEAS BANK</a
                >
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹43.53
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                <span class="text-table-negative">-4.53<!-- -->%</span>
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                38,96,899
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹82,282.20
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹75.55
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹43.20
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹45.60
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                26.71
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div
                class="flex cursor-pointer items-center break-words justify-start"
                style="word-break: break-word"
              >
                <a
                  href="/stocks/suzlon-energy-limited-share-price/INE040H01021/"
                  >SUZLON ENERGY LIMITED</a
                >
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹49.71
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                <span class="text-table-negative">-4.64<!-- -->%</span>
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                9,31,89,545
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹67,842.59
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹86.04
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹35.50
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹52.13
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                60.62
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div
                class="flex cursor-pointer items-center break-words justify-start"
                style="word-break: break-word"
              >
                <a
                  href="/stocks/vodafone-idea-limited-share-price/INE669E01016/"
                  >VODAFONE IDEA LIMITED</a
                >
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹7.55
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                <span class="text-table-negative">-3.2<!-- -->%</span>
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                48,24,46,321
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹53,901.74
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹19.18
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹6.61
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹7.80
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                NA
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div
                class="flex cursor-pointer items-center break-words justify-start"
                style="word-break: break-word"
              >
                <a href="/stocks/yes-bank-limited-share-price/INE528G01035/"
                  >YES BANK LIMITED</a
                >
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹16.75
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                <span class="text-table-negative">-3.51<!-- -->%</span>
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                13,33,32,262
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹52,516.06
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹28.55
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹16.66
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹17.36
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                24.63
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div
                class="flex cursor-pointer items-center break-words justify-start"
                style="word-break: break-word"
              >
                <a href="/stocks/uco-bank-share-price/INE691A01018/"
                  >UCO BANK</a
                >
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹36.37
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                <span class="text-table-negative">-3.39<!-- -->%</span>
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                37,35,621
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹43,483.82
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹62.35
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹35.90
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹37.65
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                18.94
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div
                class="flex cursor-pointer items-center break-words justify-start"
                style="word-break: break-word"
              >
                <a
                  href="/stocks/central-bank-of-india-share-price/INE483A01010/"
                  >CENTRAL BANK OF INDIA</a
                >
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹43.98
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                <span class="text-table-negative">-2.99<!-- -->%</span>
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                38,23,394
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹38,178.77
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹73.00
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹43.25
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹45.34
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                10.86
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div
                class="flex cursor-pointer items-center break-words justify-start"
                style="word-break: break-word"
              >
                <a href="/stocks/bank-of-maharashtra-share-price/INE457A01014/"
                  >BANK OF MAHARASHTRA</a
                >
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹46.41
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                <span class="text-table-negative">-2.94<!-- -->%</span>
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                66,60,725
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹35,696.51
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹73.50
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹46.11
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹47.82
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                6.93
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div
                class="flex cursor-pointer items-center break-words justify-start"
                style="word-break: break-word"
              >
                <a href="/stocks/punjab-sind-bank-share-price/INE608A01012/"
                  >PUNJAB &amp; SIND BANK</a
                >
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹40.24
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                <span class="text-table-negative">-4.34<!-- -->%</span>
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                7,87,480
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹27,273.81
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹73.64
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹40.10
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹42.07
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                32.72
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div
                class="flex cursor-pointer items-center break-words justify-start"
                style="word-break: break-word"
              >
                <a href="/stocks/irb-infra-dev-ltd-share-price/INE821I01022/"
                  >IRB INFRA DEV LTD.</a
                >
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹43.26
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                <span class="text-table-negative">-4.37<!-- -->%</span>
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                2,75,47,832
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹26,124.71
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹78.15
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹42.68
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹45.24
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                28.09
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div
                class="flex cursor-pointer items-center break-words justify-start"
                style="word-break: break-word"
              >
                <a
                  href="/stocks/motherson-sumi-wrng-ind-l-share-price/INE0FS801015/"
                  >MOTHERSON SUMI WRNG IND L</a
                >
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹47.00
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                <span class="text-table-negative">-0.52<!-- -->%</span>
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                78,50,112
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹20,779.21
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹80.00
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹46.08
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹47.25
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                33.10
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div
                class="flex cursor-pointer items-center break-words justify-start"
                style="word-break: break-word"
              >
                <a
                  href="/stocks/sagility-india-limited-share-price/INE0W2G01015/"
                  >SAGILITY INDIA LIMITED</a
                >
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹42.86
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                <span class="text-table-negative">-0.48<!-- -->%</span>
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                53,78,786
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹20,064.17
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹56.40
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹27.02
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹43.07
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                NA
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div
                class="flex cursor-pointer items-center break-words justify-start"
                style="word-break: break-word"
              >
                <a href="/stocks/reliance-power-ltd-share-price/INE614G01033/"
                  >RELIANCE POWER LTD.</a
                >
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹33.26
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                <span class="text-table-negative">-4.28<!-- -->%</span>
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                2,78,73,488
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹13,360.45
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹53.64
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹19.40
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹34.75
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                NA
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div
                class="flex cursor-pointer items-center break-words justify-start"
                style="word-break: break-word"
              >
                <a href="/stocks/trident-limited-share-price/INE064C01022/"
                  >TRIDENT LIMITED</a
                >
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹25.79
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                <span class="text-table-negative">-3.15<!-- -->%</span>
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                55,85,055
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹13,142.47
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹44.50
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹25.47
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹26.63
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                45.25
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div
                class="flex cursor-pointer items-center break-words justify-start"
                style="word-break: break-word"
              >
                <a href="/stocks/ifci-ltd-share-price/INE039A01010/"
                  >IFCI LTD</a
                >
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹41.09
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                <span class="text-table-negative">-3.52<!-- -->%</span>
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                90,07,328
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹10,739.25
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹91.40
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹35.80
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹42.59
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                46.69
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div
                class="flex cursor-pointer items-center break-words justify-start"
                style="word-break: break-word"
              >
                <a href="/stocks/nmdc-steel-limited-share-price/INE0NNS01018/"
                  >NMDC STEEL LIMITED</a
                >
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹35.40
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                <span class="text-table-negative">-2.8<!-- -->%</span>
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                37,38,746
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹10,374.34
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹68.94
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹34.95
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹36.42
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                NA
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div
                class="flex cursor-pointer items-center break-words justify-start"
                style="word-break: break-word"
              >
                <a
                  href="/stocks/jaiprakash-power-ven-ltd-share-price/INE351F01018/"
                  >JAIPRAKASH POWER VEN. LTD</a
                >
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹13.36
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                <span class="text-table-negative">-4.09<!-- -->%</span>
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                2,53,36,889
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹9,156.22
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹23.77
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹12.85
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹13.93
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                5.94
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div
                class="flex cursor-pointer items-center break-words justify-start"
                style="word-break: break-word"
              >
                <a
                  href="/stocks/alok-industries-limited-share-price/INE270A01029/"
                  >ALOK INDUSTRIES LIMITED</a
                >
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹15.36
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                <span class="text-table-negative">-2.78<!-- -->%</span>
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                41,33,792
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹7,626.61
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹32.00
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹15.23
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹15.80
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                NA
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div
                class="flex cursor-pointer items-center break-words justify-start"
                style="word-break: break-word"
              >
                <a href="/stocks/mmtc-limited-share-price/INE123F01029/"
                  >MMTC LIMITED</a
                >
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹49.49
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                <span class="text-table-negative">-2.77<!-- -->%</span>
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                17,96,035
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹7,423.50
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹131.80
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹48.01
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹50.90
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                73.87
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div
                class="flex cursor-pointer items-center break-words justify-start"
                style="word-break: break-word"
              >
                <a
                  href="/stocks/network18-media-inv-ltd-share-price/INE870H01013/"
                  >NETWORK18 MEDIA &amp; INV LTD</a
                >
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹41.32
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                <span class="text-table-negative">-5.07<!-- -->%</span>
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                59,20,519
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹6,371.54
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹120.00
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹40.84
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹43.53
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                NA
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div
                class="flex cursor-pointer items-center break-words justify-start"
                style="word-break: break-word"
              >
                <a
                  href="/stocks/the-south-indian-bank-ltd-share-price/INE683A01023/"
                  >THE SOUTH INDIAN BANK LTD</a
                >
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹23.80
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                <span class="text-table-negative">-3.13<!-- -->%</span>
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                95,35,474
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹6,226.78
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹33.70
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹22.27
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹24.57
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                4.86
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div
                class="flex cursor-pointer items-center break-words justify-start"
                style="word-break: break-word"
              >
                <a
                  href="/stocks/ujjivan-small-financ-bank-share-price/INE551W01018/"
                  >UJJIVAN SMALL FINANC BANK</a
                >
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹32.13
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                <span class="text-table-negative">-1.5<!-- -->%</span>
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                1,36,63,822
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹6,216.46
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹56.70
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹30.88
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹32.62
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                6.17
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div
                class="flex cursor-pointer items-center break-words justify-start"
                style="word-break: break-word"
              >
                <a href="/stocks/pc-jeweller-ltd-share-price/INE785M01021/"
                  >PC JEWELLER LTD</a
                >
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹11.31
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                <span class="text-table-positive">1.98<!-- -->%</span>
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                2,21,68,096
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹6,108.39
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹19.29
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹4.41
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹11.09
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                17.67
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div
                class="flex cursor-pointer items-center break-words justify-start"
                style="word-break: break-word"
              >
                <a href="/stocks/hmt-ltd-share-price/INE262A01018/"
                  >HMT LTD -</a
                >
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹49.05
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                <span class="text-table-negative">-3.38<!-- -->%</span>
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                18,691
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹5,906.07
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹105.00
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹41.05
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹50.77
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                NA
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div
                class="flex cursor-pointer items-center break-words justify-start"
                style="word-break: break-word"
              >
                <a
                  href="/stocks/lloyds-enterprises-ltd-share-price/INE080I01025/"
                  >LLOYDS ENTERPRISES LTD</a
                >
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹46.40
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                <span class="text-table-positive">2.18<!-- -->%</span>
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                92,07,562
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹5,902.67
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹63.00
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹41.28
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹45.41
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                NA
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div
                class="flex cursor-pointer items-center break-words justify-start"
                style="word-break: break-word"
              >
                <a
                  href="/stocks/shree-renuka-sugars-ltd-share-price/INE087H01022/"
                  >SHREE RENUKA SUGARS LTD</a
                >
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹27.51
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                <span class="text-table-negative">-3.91<!-- -->%</span>
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                61,03,602
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹5,855.48
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹56.50
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹27.10
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                ₹28.63
              </div>
            </td>
            <td>
              <div
                class="flex cursor-pointer items-center justify-end break-words"
                style="word-break: break-word"
              >
                NA
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <p
      class="mx-auto mt-3 text-[10px] leading-[15px] tracking-[-0.1px] text-text-2 4xl:max-w-[1792px]"
    >
      *Disclaimer: The scripts listed are solely for research purposes and are
      not recommendations. Please conduct your own research before making any
      investment decisions.
    </p>
    <div class="mx-auto mt-6 flex justify-between 4xl:max-w-[1792px]">
      <div class="hidden items-center md:flex">
        <p class="mr-2 text-text-2">Results per page:</p>
        <div
          class="flex h-10 w-10 cursor-pointer items-center justify-center rounded-lg bg-table-paginationBg font-semibold text-text-link"
        >
          <p>25</p>
        </div>
        <div
          class="flex h-10 w-10 cursor-pointer items-center justify-center rounded-lg"
        >
          <p>50</p>
        </div>
        <div
          class="flex h-10 w-10 cursor-pointer items-center justify-center rounded-lg"
        >
          <p>100</p>
        </div>
      </div>
      <div class="flex flex-col md:hidden">
        <p
          class="mr-2 text-[10px] leading-[15px] tracking-[-0.10px] text-text-2"
        >
          Results per page:
        </p>
        <div
          class="mt-1 flex h-[34px] w-[81px] cursor-pointer items-center justify-between rounded-lg border border-table-border px-2"
        >
          <p class="text-xs font-semibold leading-[18px] tracking-[-0.12px]">
            25
          </p>
          <img
            alt="filter up"
            loading="lazy"
            width="12"
            height="12"
            decoding="async"
            data-nimg="1"
            class="rotate-90"
            style="color: transparent"
            src="/next-scrip-assets/pagination-arrow.svg"
          />
        </div>
      </div>
      <div class="flex items-center">
        <div class="mr-2 h-4 w-4">
          <img
            alt="filter up"
            loading="lazy"
            width="16"
            height="16"
            decoding="async"
            data-nimg="1"
            class="rotate-180 filter-gray"
            style="color: transparent"
            src="/next-scrip-assets/pagination-arrow.svg"
          />
        </div>
        <div
          class="flex h-10 w-10 cursor-pointer items-center justify-center rounded-lg bg-table-paginationBg font-semibold text-text-link"
        >
          <p>1</p>
        </div>
        <div
          class="flex h-10 w-10 cursor-pointer items-center justify-center rounded-lg"
        >
          <p>2</p>
        </div>
        <div
          class="flex h-10 w-10 cursor-pointer items-center justify-center rounded-lg"
        >
          <p>3</p>
        </div>
        <div
          class="flex h-10 w-10 cursor-pointer items-center justify-center rounded-lg"
        >
          <p>4</p>
        </div>
        <div
          class="flex h-10 w-10 cursor-pointer items-center justify-center rounded-lg"
        >
          <p>5</p>
        </div>
        <div class="ml-2 h-4 w-4">
          <img
            alt="filter up"
            loading="lazy"
            width="16"
            height="16"
            decoding="async"
            data-nimg="1"
            class=""
            style="color: transparent"
            src="/next-scrip-assets/pagination-arrow.svg"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
</style>
